import { InjectionToken } from "@angular/core";
import { StaffEmployeesPort } from "./staff-employees.port";

export const STAFF_EMPLOYEES_PORT = new InjectionToken<StaffEmployeesPort>(
  "STAFF_EMPLOYEES_PORT",
);
